import { CheckCircle2, X } from 'lucide-react';
import { Badge } from '../ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableRowHeader,
} from '../ui/table';
import type { ColumnMappingTableProps, CsvColumnMapping } from './types';

export function ColumnMappingTable({ columnMappings }: ColumnMappingTableProps) {
  return (
    <div className="h-[350px] rounded-md border overflow-auto">
      <Table caption="CSV column mapping">
        <TableHeader>
          <TableRow>
            <TableHead>Source Column</TableHead>
            <TableHead>Position</TableHead>
            <TableHead>Required</TableHead>
            <TableHead>Matched</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {columnMappings.map((mapping: CsvColumnMapping) => (
            <TableRow
              key={`${mapping.source_column}-${mapping.source_position}`}
              className={mapping.is_required && !mapping.is_matched ? 'bg-red-50/50' : ''}
            >
              <TableRowHeader className="font-medium">{mapping.source_column}</TableRowHeader>
              <TableCell>{mapping.source_position}</TableCell>
              <TableCell>
                {mapping.is_required ? (
                  <Badge variant="secondary">Required</Badge>
                ) : (
                  <span className="text-muted-foreground">Optional</span>
                )}
              </TableCell>
              <TableCell>
                {mapping.is_matched ? (
                  <CheckCircle2 className="h-4 w-4 text-emerald-600" />
                ) : (
                  <X className="h-4 w-4 text-red-600" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
